import { styled } from '$utils/theme'
import { rem } from 'polished'

interface Props {
  login?: boolean
  noTop?: boolean
  height?: number
}
export const FormContainer = styled.div.attrs({})<Props>`
  max-width: ${p => (p.login ? rem(p.theme.loginFormMaxWidth) : rem(p.theme.formMaxWidth))};
  margin: auto;
  ${p => p.theme.media.desktop`margin-top: ${p.noTop ? rem(p.theme.sizes.none) : rem(p.theme.sizes.small)}`};
  ${p =>
    p.height &&
    `
    height: ${p.height}%;
  `}
`



// WEBPACK FOOTER //
// ./src/views/components/FormContainer/FormContainer.tsx